(function () {
  function initCustomStickyATC() {
    const sticky = document.querySelector('[data-custom-sticky-atc]');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const stickyButton = sticky.querySelector('[data-custom-sticky-atc-button]');
    const stickyVariantSelect = sticky.querySelector('[data-custom-sticky-variant-select]');
    const stickyPrice = sticky.querySelector('[data-custom-sticky-price]');
    const stickyQtyInput = sticky.querySelector('[data-custom-sticky-qty-input]');
    const stickyQtyMinus = sticky.querySelector('[data-custom-sticky-qty-minus]');
    const stickyQtyPlus = sticky.querySelector('[data-custom-sticky-qty-plus]');

    const productForm = document.querySelector('.product-single__form');
    if (!stickyButton || !productForm) return;

    const mainButton = productForm.querySelector('[data-add-to-cart]');
    const mainVariantSelect = productForm.querySelector('[name="id"]');
    let mainQtyInput = productForm.querySelector('[name="quantity"]');
    
    if (!mainQtyInput) {
        mainQtyInput = document.createElement('input');
        mainQtyInput.type = 'hidden';
        mainQtyInput.name = 'quantity';
        mainQtyInput.value = '1';
        productForm.appendChild(mainQtyInput);
}

    if (!mainButton) return;

    sticky.dataset.initialized = 'true';

    function getRealAddToCartButton() {
      const bundleButton = productForm.querySelector('[data-bundle-submit="true"]');
      return bundleButton || mainButton;
    }

    function setQuantity(value, options) {
  const shouldDispatch = options && options.dispatch === true;

  let qty = parseInt(value || '1', 10);
  if (isNaN(qty) || qty < 1) qty = 1;

  if (stickyQtyInput && stickyQtyInput.value !== String(qty)) {
    stickyQtyInput.value = qty;
  }

  if (mainQtyInput && mainQtyInput.value !== String(qty)) {
    mainQtyInput.value = qty;
    mainQtyInput.setAttribute('value', qty);

    if (shouldDispatch) {
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateStickyTotalPrice();
}

    function syncVariantToMainForm(variantId) {
      if (!variantId || !mainVariantSelect) return;

      mainVariantSelect.value = variantId;

      mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      mainVariantSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function getCurrentUnitPrice() {
  if (stickyVariantSelect) {
    const selectedOption = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];
    if (selectedOption) {
      return parseInt(selectedOption.getAttribute('data-price') || '0', 10);
    }
  }

  const priceText = stickyPrice ? stickyPrice.getAttribute('data-unit-price') : null;
  return parseInt(priceText || '0', 10);
}

function updateStickyPriceFromOption(option) {
  if (!option || !stickyPrice) return;

  const price = parseInt(option.getAttribute('data-price') || '0', 10);
  stickyPrice.setAttribute('data-unit-price', price);

  updateStickyTotalPrice();
}

function updateStickyTotalPrice() {
  if (!stickyPrice) return;

  const unitPrice = getCurrentUnitPrice();
  const qty = stickyQtyInput ? parseInt(stickyQtyInput.value || '1', 10) : 1;
  const totalPrice = unitPrice * Math.max(qty, 1);

  if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
    stickyPrice.textContent = theme.Currency.formatMoney(totalPrice, theme.settings.moneyFormat);
  }
}

    function syncStickyVariantFromMainForm() {
      if (!stickyVariantSelect || !mainVariantSelect) return;

      const currentVariantId = mainVariantSelect.value;
      if (!currentVariantId) return;

      stickyVariantSelect.value = currentVariantId;

      const selectedOption = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];
      updateStickyPriceFromOption(selectedOption);
    }

    function mirrorButtonState() {
      const realButton = getRealAddToCartButton();
      if (!realButton) return;

      const realTextEl = realButton.querySelector('[data-add-to-cart-text]');
      const realText = realTextEl ? realTextEl.textContent.trim() : realButton.textContent.trim();

      if (realText) {
        stickyButton.textContent = realText;
      }

      const isDisabled = realButton.disabled || realButton.hasAttribute('disabled');

      stickyButton.disabled = isDisabled;
      stickyButton.classList.toggle('is-disabled', isDisabled);
    }

    function toggleStickyVisibility() {
      const rect = mainButton.getBoundingClientRect();
      const shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;

      sticky.classList.toggle('is-visible', shouldShow);
    }

    if (stickyVariantSelect) {
      stickyVariantSelect.addEventListener('change', function () {
        const selectedOption = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];

        syncVariantToMainForm(stickyVariantSelect.value);
        updateStickyPriceFromOption(selectedOption);

        setTimeout(function () {
          mirrorButtonState();
        }, 100);
      });
    }

    if (mainVariantSelect) {
      mainVariantSelect.addEventListener('change', function () {
        syncStickyVariantFromMainForm();

        setTimeout(function () {
          mirrorButtonState();
        }, 100);
      });
    }

    if (stickyQtyMinus) {
      stickyQtyMinus.addEventListener('click', function () {
        setQuantity(parseInt(stickyQtyInput.value || '1', 10) - 1);
      });
    }

    if (stickyQtyPlus) {
      stickyQtyPlus.addEventListener('click', function () {
        setQuantity(parseInt(stickyQtyInput.value || '1', 10) + 1);
      });
    }

    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('change', function () {
        setQuantity(stickyQtyInput.value);
      });

      stickyQtyInput.addEventListener('input', function () {
        setQuantity(stickyQtyInput.value);
      });
    }

    if (mainQtyInput) {
  mainQtyInput.addEventListener('change', function () {
    setQuantity(mainQtyInput.value, { dispatch: false });
  });

  mainQtyInput.addEventListener('input', function () {
    setQuantity(mainQtyInput.value, { dispatch: false });
  });
}

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (stickyVariantSelect) {
        syncVariantToMainForm(stickyVariantSelect.value);
      }

      if (stickyQtyInput) {
        setQuantity(stickyQtyInput.value, { dispatch: true });
      }

      const realButton = getRealAddToCartButton();
      if (!realButton || realButton.disabled || realButton.hasAttribute('disabled')) return;

      realButton.click();
    });

    document.addEventListener('variant:change', function () {
      syncStickyVariantFromMainForm();

      setTimeout(function () {
        mirrorButtonState();
      }, 100);
    });

    const observer = new MutationObserver(function () {
      mirrorButtonState();
      syncStickyVariantFromMainForm();
    });

    observer.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('scroll', toggleStickyVisibility, { passive: true });
    window.addEventListener('resize', toggleStickyVisibility);

    syncStickyVariantFromMainForm();
    setQuantity(mainQtyInput ? mainQtyInput.value : 1);
    mirrorButtonState();
    toggleStickyVisibility();
  }

  document.addEventListener('DOMContentLoaded', initCustomStickyATC);
  document.addEventListener('page:loaded', initCustomStickyATC);
  document.addEventListener('shopify:section:load', initCustomStickyATC);
})();